<template>
    <div class="top">
        <p class="bg-rave">RAVEBRB</p>
        <p><span>RAVEBRB</span></p>
        <p>ORIGINAL WEBSITE</p>
    </div>
</template>